import { AnyAction } from "@reduxjs/toolkit";
import * as actionType from "../../redux/actions/types";

export interface AppState {
  isInitialize: boolean;
  references: any;
  referencesFilter: number[];
  selectSource: any[];
  threads: any[];
  thread: any;
  threadFull: any;
  isMobile: boolean;
  menuIsOpen: boolean;
  product: any;
  main_product: any;
  products: any;
  feedFilterIsOpen: boolean;
}

const initialState: AppState = {
  isInitialize: true,
  references: [],
  referencesFilter: [],
  selectSource: [],
  threads: [],
  product: null,
  main_product: {},
  products: [],
  thread: null,
  threadFull: 23022,
  isMobile: window.innerWidth <= 850,
  menuIsOpen: false,
  feedFilterIsOpen: false,
};

export const appReducer = (
  state = initialState,
  { type, payload }: AnyAction
): AppState => {
  switch (type) {
    case actionType.SET_APP_IS_INITIALIZE: {
      return { ...state, isInitialize: payload };
    }
    case actionType.SET_APP_IS_MOBILE: {
      return { ...state, isMobile: payload };
    }
    case actionType.SHOW_MENU: {
      return { ...state, menuIsOpen: true };
    }
    case actionType.HIDE_MENU: {
      return { ...state, menuIsOpen: false };
    }
    case actionType.SET_THREAD: {
      if (payload) {
        const thread = {
          id: payload.id,
          retro: payload.retro,
        };
        return { ...state, thread };
      } else {
        return { ...state };
      }
    }
    case actionType.SET_THREAD_FULL: {
      if (payload) {
        return { ...state, threadFull: payload };
      } else {
        return { ...state };
      }
    }
    case actionType.SET_THREADS: {
      return { ...state, threads: payload };
    }
    case actionType.SET_PRODUCT: {
      return { ...state, product: payload };
    }
    case actionType.RESET_PRODUCT: {
      return { ...state, product: null };
    }
    case actionType.SET_MAIN_PRODUCT: {
      return { ...state, main_product: payload };
    }
    case actionType.SET_PRODUCTS: {
      return { ...state, products: payload };
    }
    case actionType.SET_REFERENCES: {
      return { ...state, references: payload };
    }
    case actionType.SET_REFERENCES_FILTER: {
      return { ...state, referencesFilter: payload };
    }
    case actionType.SET_SELECTED_REF_SOURCE: {
      return { ...state, selectSource: payload };
    }
    default:
      return state;
  }
};
